import './styles.scss'

const ServiceBlockWrapper = ({ title, children }) => {
  return (
    <div className="service-information">
      <h3 className="service-information__header">{title}</h3>
      <div className="service-information__content">{children}</div>
    </div>
  )
}

export default ServiceBlockWrapper
